// extracted by mini-css-extract-plugin
export default {"bigValue":"styles_bigValue__DTg3r"};